import {request} from "../../request";

export const ModifierRequests = {
  fetchPresets: () => {
    return request("modifiers/presets", "GET");
  },
};
